export default class PaperSize {
}
PaperSize.endpoint = '/v1/paper-sizes';
